<div class="border rounded mb-3">

  <!-- Linha resumo -->
  <div class="d-flex align-items-center justify-content-between p-2 bg-light"
    (click)="toggleExpand()" style="cursor: pointer;">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <strong>{{ doc.titulo }}</strong>
      <span class="text-muted small">| {{ doc.codigoReferencia }}</span>
      <span class="text-muted small">| {{ doc.processo }}</span>
      <span class="text-muted small">| Vence: {{ doc.vigenciaFim | date:'dd/MM/yyyy' }}</span>
      <span *ngIf="aguardandoRevisao" class="badge bg-info text-dark">Aguardando Revisão</span>
    </div>
    <div class="d-flex gap-1" (click)="$event.stopPropagation()">
      <button class="btn btn-sm btn-outline-primary" (click)="navegar.emit(doc)" title="Visualizar no SGI">
        <i class='bx bx-link-external'></i>
      </button>
      <button class="btn btn-sm btn-outline-secondary" (click)="toggleExpand()"
        [title]="expandido ? 'Recolher' : 'Expandir para enviar revisão'">
        <i class='bx' [ngClass]="expandido ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
      </button>
    </div>
  </div>

  <!-- Painel expandido -->
  <div *ngIf="expandido" class="p-3 border-top">

    <!-- Alerta de reprovação anterior -->
    <div *ngIf="doc.motivoUltimaReprovacao" class="alert alert-warning mb-3">
      <strong><i class='bx bx-error me-1'></i>Documento Reprovado</strong>
      <br>
      <span>Motivo informado pelo SGI: <em>{{ doc.motivoUltimaReprovacao }}</em></span>
      <span *ngIf="doc.dataUltimaAnaliseReprovacao" class="text-muted ms-2 small">
        em {{ doc.dataUltimaAnaliseReprovacao | date:'dd/MM/yyyy' }}
      </span>
    </div>

    <!-- Dados completos do documento -->
    <div class="row g-2 mb-3">
      <div class="col-md-4"><strong>Título:</strong> {{ doc.titulo }}</div>
      <div class="col-md-4"><strong>Código:</strong> {{ doc.codigoReferencia }}</div>
      <div class="col-md-4"><strong>Processo:</strong> {{ doc.processo }}</div>
      <div class="col-md-4"><strong>Tipo:</strong> {{ doc.tipoInformacao }}</div>
      <div class="col-md-4"><strong>Origem:</strong> {{ doc.origem }}</div>
      <div class="col-md-4"><strong>Autor / Órgão:</strong> {{ doc.autorOrgaoEmissor || doc.usuarioAutorNome || '—' }}</div>
      <div class="col-md-4"><strong>Vigência Início:</strong> {{ doc.vigenciaInicio | date:'dd/MM/yyyy' }}</div>
      <div class="col-md-4"><strong>Vigência Fim:</strong> {{ doc.vigenciaFim | date:'dd/MM/yyyy' }}</div>
      <div class="col-md-4"><strong>Versão Atual:</strong> {{ doc.versao }}</div>
    </div>

    <!-- Anexos atuais -->
    <div class="mb-3">
      <strong><i class='bx bx-paperclip me-1'></i>Documentação atual (vencida):</strong>
      <div *ngIf="carregandoAnexos" class="text-muted small mt-1">
        <div class="spinner-border spinner-border-sm me-1"></div> Carregando...
      </div>
      <ul *ngIf="!carregandoAnexos && anexos.length > 0" class="list-unstyled mt-1 mb-0">
        <li *ngFor="let anx of anexos" class="d-flex align-items-center gap-3 mb-1 flex-wrap">
          <a [href]="linkAnexo + anx.anexo" target="_blank" class="text-primary text-decoration-none">
            <i class='bx bx-link-external me-1'></i>{{ anx.nome }}
          </a>
          <span class="text-muted small">
            <i class='bx bx-user me-1'></i>{{ anx.usuarioCriacaoNome || '—' }}
          </span>
          <span class="text-muted small">
            <i class='bx bx-calendar me-1'></i>{{ anx.dataCriacao ? (anx.dataCriacao | dataUtc:'dd/MM/yyyy') : '—' }}
          </span>
        </li>
      </ul>
      <div *ngIf="!carregandoAnexos && anexos.length === 0" class="text-muted small mt-1">
        Nenhum anexo cadastrado.
      </div>
    </div>

    <!-- Aguardando revisão -->
    <div *ngIf="aguardandoRevisao" class="alert alert-info">
      <i class='bx bx-time me-1'></i>
      Solicitação enviada com sucesso. Aguardando análise do SGI.
    </div>

    <!-- Formulário de envio -->
    <ng-container *ngIf="!aguardandoRevisao">

      <!-- Analisou e nada mudou: dispensa o anexo, que só existe para carregar a versão
           nova. Chega marcado na análise do SGI, que confirma ou desmarca. -->
      <div class="alert alert-light border mb-3">
        <div class="form-check mb-1">
          <input class="form-check-input" type="checkbox" [id]="'semAlteracao-' + doc.id"
            [(ngModel)]="semAlteracao" (ngModelChange)="onSemAlteracaoChange()">
          <label class="form-check-label" [for]="'semAlteracao-' + doc.id">
            <strong>Documento não sofreu alteração</strong>
          </label>
        </div>
        <div class="form-text mb-0">
          Marque quando a análise não exigiu mudança no conteúdo. O envio dispensa o arquivo,
          a versão atual é mantida e o SGI recebe a solicitação já sinalizada.
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">
          Observações <span class="text-danger">*</span>
        </label>
        <textarea class="form-control" rows="3"
          [placeholder]="semAlteracao
            ? 'Descreva o que foi analisado e por que o documento segue válido...'
            : 'Descreva o que foi alterado no documento...'"
          [(ngModel)]="observacao">
        </textarea>
      </div>

      <div class="mb-3" *ngIf="!semAlteracao">
        <label class="form-label fw-semibold">
          Nova versão do documento <span class="text-danger">*</span>
        </label>
        <input type="file" class="form-control" multiple
          (change)="onFileSelected($event)"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png">
        <div class="form-text">PDF, DOC, DOCX, XLS, XLSX, imagens — múltiplos arquivos permitidos.</div>
      </div>

      <div *ngIf="arquivos.length > 0 && !semAlteracao" class="mb-3">
        <ul class="list-group list-group-flush">
          <li *ngFor="let arq of arquivos; let i = index"
            class="list-group-item d-flex justify-content-between align-items-center py-1 px-2">
            <span><i class='bx bx-file me-1'></i>{{ arq.nome }}</span>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removerArquivo(i)">
              <i class='bx bx-trash'></i>
            </button>
          </li>
        </ul>
      </div>

      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-primary" (click)="enviarSolicitacao()"
          [disabled]="!podEnviar">
          <span *ngIf="enviando" class="spinner-border spinner-border-sm me-1"></span>
          <i *ngIf="!enviando" class='bx bx-send me-1'></i>
          Enviar para Revisão
        </button>
      </div>
    </ng-container>

  </div>
</div>
